import { APPLICANT_TYPES } from '../util/constants';
import { useApplicantData } from './useApplicantData';
import { getApplicantData } from '../util/helpers/applicantDataHelper';

const useApplicationJointBackupWithholdings = () => {
  const MainApplicantData = useApplicantData(APPLICANT_TYPES.MAIN);
  const SecondaryApplicantData = useApplicantData(APPLICANT_TYPES.SECONDARY);

  const mainBackupWithHolding = getApplicantData(
    MainApplicantData,
    'PersonBackupWithHolding',
    'BackupWithHoldingRecord',
  );

  const secondaryBackupWithHolding = getApplicantData(
    SecondaryApplicantData,
    'PersonBackupWithHolding',
    'BackupWithHoldingRecord',
  );

  return {
    mainBackupWithHolding,
    secondaryBackupWithHolding,
  };
};

useApplicationJointBackupWithholdings.propTypes = {};

export default useApplicationJointBackupWithholdings;
